var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChitchatStep3Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_490_17812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.6484 0H25L24.0234 7.3242L25 49.9999H39.6484V0Z",
    fill: "#283366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3516 0H25V49.9999H10.3516V0Z",
    fill: "#404A80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7188 2.92969H25L24.0234 7.32422L25 47.0703H36.7188V2.92969Z",
    fill: "#ECE6F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2812 2.92969H25V47.0703H13.2812V2.92969Z",
    fill: "#FFF5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1973 5.85938H25L24.0234 7.32422L25 8.78906H27.1973V5.85938Z",
    fill: "#283366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.127 5.85938H33.0566V8.78906H30.127V5.85938Z",
    fill: "#24B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8027 5.85938H25V8.78906H22.8027V5.85938Z",
    fill: "#404A80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.49219 17.5781H7.42188V20.5078H4.49219V17.5781Z",
    fill: "#FFDD33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5625 11.7188H4.49219V14.6484H1.5625V11.7188Z",
    fill: "#FFDD33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5781 35.3516H45.5078V38.2812H42.5781V35.3516Z",
    fill: "#FFBB33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5078 29.4922H48.4375V32.4219H45.5078V29.4922Z",
    fill: "#FFBB33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5884 11.7188H35.3516L34.375 19.043L35.3516 26.3672H42.6758C44.6502 26.3672 46.5014 25.5933 47.8885 24.1881C49.2753 22.7831 50.025 20.9215 49.9994 18.9462C49.9477 14.9609 46.6231 11.7188 42.5884 11.7188Z",
    fill: "#1F8599"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0273 11.7188C23.9888 11.7188 20.7031 15.0044 20.7031 19.043V26.3672H35.3516V11.7188H28.0273Z",
    fill: "#24B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5884 14.6484H35.3516L34.375 19.043L35.3516 23.4375H42.6758C43.8604 23.4375 44.9712 22.9731 45.8034 22.13C46.6355 21.287 47.0854 20.1698 47.0699 18.9842C47.0389 16.5935 45.0284 14.6484 42.5884 14.6484Z",
    fill: "#24B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0273 14.6484C25.6042 14.6484 23.6328 16.6198 23.6328 19.043V23.4375H35.3516V14.6484H28.0273Z",
    fill: "#00DDC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8164 17.5781H35.3516L34.375 19.043L35.3516 20.5078H36.8164V17.5781Z",
    fill: "#283366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8867 17.5781H35.3516V20.5078H33.8867V17.5781Z",
    fill: "#404A80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7461 17.5781H42.6758V20.5078H39.7461V17.5781Z",
    fill: "#283366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0273 17.5781H30.957V20.5078H28.0273V17.5781Z",
    fill: "#404A80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2969 36.6211C29.2969 32.5825 26.0112 29.2969 21.9727 29.2969H14.6484L13.6719 36.6211L14.6484 43.9453H29.2969V36.6211Z",
    fill: "#FFBB33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.41167 29.2969C3.377 29.2969 0.0523917 32.5391 0.000633906 36.5243C-0.024952 38.4996 0.724755 40.3612 2.11157 41.7662C3.49868 43.1714 5.34985 43.9453 7.32427 43.9453H14.6485V29.2969H7.41167Z",
    fill: "#FFDD33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3672 36.6211C26.3672 34.1979 24.3958 32.2266 21.9727 32.2266H14.6484L13.6719 36.6211L14.6484 41.0156H26.3672V36.6211Z",
    fill: "#FFDD33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.41161 32.2267C4.97158 32.2267 2.96113 34.1717 2.93007 36.5624C2.91464 37.748 3.36445 38.8652 4.19658 39.7081C5.0288 40.5513 6.13954 41.0156 7.32421 41.0156H14.6484V32.2266H7.41161V32.2267Z",
    fill: "#FFEE99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1133 35.1562H14.6484L13.6719 36.6211L14.6484 38.0859H16.1133V35.1562Z",
    fill: "#283366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.32422 35.1562H10.2539V38.0859H7.32422V35.1562Z",
    fill: "#283366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.043 35.1562H21.9727V38.0859H19.043V35.1562Z",
    fill: "#283366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1836 35.1562H14.6484V38.0859H13.1836V35.1562Z",
    fill: "#404A80"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_490_17812"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChitchatStep3Icon);
export default __webpack_public_path__ + "static/media/chitchat_step3_icon.72a720e1ebb1fd7141a56ec2fd103450.svg";
export { ForwardRef as ReactComponent };